export const ROOM_ENTRY_PASSWORD = import.meta.env.VITE_PARTY_SCREEN_PASSWORD || 'qaz12345';

const STORAGE_KEY = 'party_screen_entry_ok';

export function isRoomEntryGranted() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function grantRoomEntry() {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function verifyRoomEntryPassword(input) {
  return String(input || '').trim() === ROOM_ENTRY_PASSWORD;
}
